import { MouseEventHandler, ReactNode } from "react"
import cn from "classnames"

import { Text } from "ui-kit/components-branded/Text"

interface Props {
    className?: string
    id?: string
    checked?: boolean
    disabled?: boolean
    label?: ReactNode
    onClick: MouseEventHandler<HTMLInputElement>
}
export function Toggle({ className, id, checked, disabled, label, onClick }: Props) {
    return (
        <div
            className={cn(
                "toggle",
                "is-flex",
                "is-align-items-center",
                "user-select-none",
                {
                    "is-disabled": disabled,
                },
                {
                    "is-checked": checked,
                },
                className
            )}
        >
            <input
                id={id}
                type="checkbox"
                className="toggle__input"
                checked={checked}
                onClick={onClick}
                disabled={disabled}
            />
            <div className="toggle__check" />
            {label && (
                <label id={id} className="toggle__label">
                    <Text className="is-block ml-2">{label}</Text>
                </label>
            )}
        </div>
    )
}
